import { useOption } from "@mui/base";
import * as React from "react";
import type { FunctionComponent } from "react";

import { Option } from "./styles";

type Props = {
  children?: React.ReactNode;
  disabled?: boolean;
  isSelected: boolean;
  value: string;
};

export const DropdownSelectOption: FunctionComponent<Props> = ({
  children,
  disabled = false,
  isSelected,
  value,
}) => {
  const { getRootProps } = useOption({
    disabled,
    value,
  });

  return (
    <Option {...getRootProps()} $isSelected={isSelected}>
      {children}
    </Option>
  );
};

DropdownSelectOption.displayName = "DropdownSelectOption";
